import { NextPage, NextPageContext } from 'next'
import { Box, Typography } from '@material-ui/core'

import { ShadowHeading } from '@Components'

const ErrorPage: NextPage = (props: any) => {
  return (
    <Box py="100px" textAlign="center">
      <ShadowHeading text={props.statusCode} />
      <Box py="100px">
        <img
          height="320px"
          src="https://66.media.tumblr.com/tumblr_lrfbltAknk1qazdhko1_500.gifv"
          alt={'Something went wrong, try again.'}
        />
      </Box>
      <Typography variant="body1">
        {`${props.statusCode}: Something went wrong, try again.`}
      </Typography>
    </Box>
  )
}

ErrorPage.getInitialProps = async ({ res }: NextPageContext) => {
  const statusCode = res ? res.statusCode : null

  return {
    statusCode,
  }
}

export default ErrorPage
